import styled from "styled-components"

const EventsItemImg = styled.div`
  &::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_light}CC;
  }
`
const EventsItemDate = styled.p`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`
const EventsItemTaxo = styled.div`
  & > div {
    color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

const EventItemRecurrence = styled.p`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export { EventsItemDate, EventsItemTaxo, EventsItemImg, EventItemRecurrence }
